import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import ReimbursementSummaryCommon, {getDefaultState as getReimbursementSummaryCommonDefaultState} from './reimbursement-summary-common';

const ReimbursementSummaryLocation = ReimbursementSummaryCommon.extend({
    subAccount: Dealer
}, {
    name: 'ReimbursementSummaryLocation',
    strict: true
});

export const getDefaultState = () => new ReimbursementSummaryLocation({
    ...getReimbursementSummaryCommonDefaultState(),
    subAccount: getDealerDefaultState()
});

export default ReimbursementSummaryLocation;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-location.js